import React, { useState } from 'react';
import { Layout } from './components/Layout';
import { Login } from './components/Login';

interface User {
  username: string;
  password: string;
}

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = (credentials: { username: string; password: string }) => {
    setUser(credentials);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setUser(null);
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return <Layout onLogout={handleLogout} user={user} />;
}

export default App;
